<div fxLayout="column" fxLayoutGap="10px">
	<rpshared-offered-service
		[formControl]="control"
		rpsharedRemoveHost
	></rpshared-offered-service>
	<div mat-dialog-actions>
		<button mat-button mat-dialog-close color="warn">
			Cancel
		</button>
		<button
			mat-button
			[disabled]="group.invalid"
			color="primary"
			[mat-dialog-close]="group"
		>
			Save
		</button>
	</div>
</div>
